export default __webpack_public_path__ + "static/media/team-work-amico-consorcio.e444edef.png";